export const config = {
  apiKey: 'AIzaSyCu2OaRQkPHoOsqRi1qswozmx1tvE7QSFM',
  authDomain: 'ecc-app-eu.firebaseapp.com',
  databaseURL: 'https://ecc-app-eu.firebaseio.com',
  projectId: 'ecc-app-eu',
  storageBucket: 'ecc-app-eu.appspot.com',
  messagingSenderId: '771456758104',
  appId: '1:771456758104:web:5cd60eb9559ca3e1',
}
